/**
 * ERP Financial API client for fetching segment codes by leaf group IDs.
 */

import { baseErpRequest } from './erpRequest';
import type { ErpApiError } from './types';

export type LeafSegmentCode = {
  id: number;
  segmentCode: string;
  active: boolean;
  segmentId?: number;
  description?: string;
  defaultParentSegmentGroup?: number | null;
  tags?: string[];
  objectCodeType?: string;
  fundOrgUnitId?: number | null;
  importFileId?: number | null;
  createdBy?: string;
  updatedBy?: string;
  createdDate?: string;
  updatedDate?: string;
};

export type LeafSegmentCodesResponse = {
  message: string;
  statusCode: number;
  data: {
    results: Record<string, LeafSegmentCode[]>;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      totalCount: number;
    };
  };
  errors?: ErpApiError[] | null;
};

export type GetLeafSegmentCodesParams = {
  leafGroupIds: number[];
};

export const getLeafSegmentCodes = async (
  { leafGroupIds }: GetLeafSegmentCodesParams,
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<LeafSegmentCodesResponse> => {
  return await baseErpRequest('/groups/leaf/segment-codes', clientOptions, hostUrl)
    .json({ leafGroupIds })
    .post()
    .json();
};
